import affiliations from './affiliations';
import bulkInserts from './bulkInserts';
import catalogs from './catalogs';
import groups from './groups';
import inventories from './inventories';
import notifications from './notifications';
import schedules from './schedules';

export default [
  {
    header: 'sidebar.administration',
    iconName: 'Sliders',
    children: [
      ...affiliations,
      ...groups,
      ...schedules,
      ...catalogs,
      ...inventories,
      ...notifications,
      ...bulkInserts
    ] //Only to check permission in children inside
  },
  ...affiliations,
  ...groups,
  ...schedules,
  ...catalogs,
  ...inventories,
  ...notifications,
  ...bulkInserts
];
